export const estadoActivo: number = 1;
export const estadoInactivo: number = 0;
